import React from 'react';
import {
  Checkbox,
} from 'anf-core-react';
import * as FormStructure from '../../FormStructure';
import { LegalSectionPropTypes, LegalSectionDefaultProps } from './props';
import LegalText from './LegalText';

/**
 * Legal compliance section for terms and conditions
 * Renders privacy terms text and legal agreement checkbox with validation
 *
 * @param {Object} props - Component properties
 * @param {Object} props.joinFormPrivacyTerms - Privacy terms text configuration
 * @param {boolean} props.joinLegalCheck - Whether legal checkbox is required
 * @param {Object} props.joinLegalText - Legal agreement text content
 * @param {Object} props.legalField - React Hook Form field object for legal checkbox
 * @param {Object} props.legalFieldState - React Hook Form field state for validation
 * @returns {JSX.Element} Legal section with terms and agreement checkbox
 */
function LegalSection({
  joinFormPrivacyTerms,
  joinLegalCheck,
  joinLegalText,
  legalField,
  legalFieldState,
}) {
  return (
    <>
      {
        joinFormPrivacyTerms && (
          <FormStructure.FormCell>
            <LegalText text={joinFormPrivacyTerms.text} />
          </FormStructure.FormCell>
        )
      }
      {
        joinLegalCheck
          ? (
            <FormStructure.FormCell>
              <Checkbox
                description={<LegalText text={joinLegalText} />}
                id="join-form-legal-check"
                isChecked={legalField.value}
                isInvalid={legalFieldState.invalid}
                isRequired
                name={legalField.name}
                onChange={legalField.onChange}
                value="y"
              />
            </FormStructure.FormCell>
          )
          : (
            <FormStructure.FormCell>
              <LegalText text={joinLegalText} />
            </FormStructure.FormCell>
          )
      }
    </>
  );
}

LegalSection.propTypes = LegalSectionPropTypes;
LegalSection.defaultProps = LegalSectionDefaultProps;

export default LegalSection;
